import { useState, useCallback } from 'react';
import { useAuthenticatedFetchWithWorkspace } from '../Keycloak/useAuthenticatedFetchWithWorkspace';

interface QueryCountResponse {
    taskId?: string;
    count?: number;
    status?: string;
    message?: string;
}

export const useQueryCount = () => {
    const { authFetch, isReady } = useAuthenticatedFetchWithWorkspace();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const launchQueryCount = useCallback(async (queryId: string | number): Promise<QueryCountResponse | null> => {
        if (!isReady || !queryId) return null;

        setLoading(true);
        setError(null);

        try {
            const response = await authFetch('/queryCount', {
                method: 'POST',
                body: JSON.stringify({ queryId: String(queryId) }),
            }) as QueryCountResponse;

            if (response?.status?.toUpperCase() === 'ERROR') {
                setError(
                    response.message?.includes('bad SQL grammar')
                        ? 'La requête génère un SQL invalide. Vérifiez les critères puis relancez le comptage.'
                        : response.message || 'Erreur lors du comptage'
                );
                return null;
            }

            return response;
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Erreur lors du comptage');
            return null;
        } finally {
            setLoading(false);
        }
    }, [authFetch, isReady]);

    const reset = useCallback(() => setError(null), []);

    return { launchQueryCount, loading, error, reset };
};

